import React from "react";

const CarouselImage = (props) => {
  return (
    <div style={{ width: "100%", height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <img
        src={props.text}
        alt=""
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "10px"
        }}
      />
    </div>
  );
};

export default CarouselImage;
